// Project Logos
export const projectLogos = {
    // Main Projects  
    aigis: '/assets/projects/aigis/logo.png',
    praxisAi: '/assets/projects/praxis-ai/logo.png',
    aixCyber: '/assets/projects/investia/logo.png',
    mediLearn: '/assets/projects/medilearn/logo.png',
    dishboard: '/assets/projects/dishboard/logo.png',
    timeConquest: '/assets/projects/time conquest/logo.png',
    hestia: '/assets/projects/hestia/logo.png',

    // Legacy aliases (for backward compatibility)
    aiChatbot: '/assets/projects/aigis/logo.png',
    blockchainVoting: '/assets/projects/investia/logo.png',
    mobileApp: '/assets/projects/medilearn/logo.png',
    webPortfolio: '/assets/projects/dishboard/logo.png',
    machineLearning: '/assets/projects/dishboard/logo.png',

    // SVG fallback for missing logos
    fallback: `data:image/svg+xml;base64,${btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
            <rect width="100" height="100" fill="#0d0d0d" stroke="#732424" stroke-width="2"/>
            <text x="50" y="35" text-anchor="middle" fill="#d92323" font-family="Arial" font-size="12" font-weight="bold">PROJECT</text>
            <text x="50" y="55" text-anchor="middle" fill="#7b7b7b" font-family="Arial" font-size="10">LOGO</text>
            <rect x="35" y="65" width="30" height="20" fill="none" stroke="#d92323" stroke-width="2" rx="3"/>
            <circle cx="42" cy="72" r="2" fill="#d92323"/>
            <circle cx="50" cy="72" r="2" fill="#d92323"/>
            <circle cx="58" cy="72" r="2" fill="#d92323"/>
        </svg>
    `)}`
};